import { motion } from "framer-motion";
import Counter from "@/components/common/Counter";
import { WHY_FEATURES } from "@/data/site";

export default function WhyChoose() {
  return (
    <section id="why" data-testid="why-section" className="relative bg-[#0F172A] text-white py-24 md:py-32 overflow-hidden">
      {/* Backdrop accents */}
      <div className="pz-blob bg-[#2563EB] w-[460px] h-[460px] top-[-160px] left-[-120px] opacity-40" />
      <div className="pz-blob bg-[#F59E0B] w-[360px] h-[360px] bottom-[-160px] right-[-100px] opacity-25" />
      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.5) 1px, transparent 1px)",
          backgroundSize: "56px 56px",
        }}
      />

      <div className="relative pz-container">
        <div className="max-w-3xl">
          <span className="pz-overline" style={{ color: "#F59E0B" }}>Why Printzee</span>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Six reasons brands<br />trust us with the details.
          </h2>
          <div className="pz-gold-line mt-6" />
          <p className="mt-6 text-white/70 text-lg max-w-2xl">
            Quality control, transparent timelines and a team that treats your brand like it&apos;s ours.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {WHY_FEATURES.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`why-card-${i}`}
              className="group relative rounded-2xl border border-white/10 bg-white/[0.04] p-7 hover:bg-white/[0.07] hover:border-[#F59E0B]/40 transition-all"
            >
              <div className="flex items-baseline gap-2">
                <div className="font-display text-5xl font-bold text-[#F59E0B] leading-none">
                  <Counter to={f.value} />
                </div>
                <span className="text-white/60 text-sm">{f.suffix}</span>
              </div>
              <h3 className="mt-6 font-display text-xl font-semibold">{f.title}</h3>
              <p className="mt-3 text-white/65 text-sm leading-relaxed">{f.desc}</p>
              <div className="mt-6 h-[1px] w-10 bg-[#F59E0B] group-hover:w-20 transition-all duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
